import React, { Suspense } from "react";
import { useRoutes } from "react-router-dom";

import Loader from "@/ui/Loader";
import NotFoundPage from "@/pages/NotFoundPage";

import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./SiteRoutes";

const AppRoutes: React.FC = () => {
  const element = useRoutes([
    ...PrivateRoutes,
    ...PublicRoutes,
    // Anything no route above matches, for signed-in and signed-out users
    // alike. RequireRole shows the same page for routes a user may not open.
    { path: "*", element: <NotFoundPage /> },
  ]);

  return <Suspense fallback={<Loader />}>{element}</Suspense>;
};

export default AppRoutes;